import React from 'react'

import { CommunityContent } from '../Membership/pages/Product/sections/Community'

import Hero from './components/Hero'
import Companies from './components/Companies'
import Highlights from './components/Highlights'
import Plans from './components/Plans'
import ROUTE from './route'
import { Props } from './data'

import Main from 'src/components/Main'
import Page from 'src/components/Page'
import SEO from 'src/components/SEO'
import FAQs from 'src/components/sections/HelpCenterArticles'
import TheSuperHiWay from 'src/components/sections/TheSuperHiWay'
import { PageConfig } from 'src/routing/types'

const Teams: PageConfig<Props> = ({ faqs, ...rest }) => (
  <Page>
    <SEO
      title="SuperHi for Teams"
      description="SuperHi For Teams offers SuperHi Unlimited memberships to all creative teams, big and small. Each team member gets access to all our design, project management and coding courses, plus extra benefits!"
      imageUrl="https://superhi.s3.amazonaws.com/assets/images/teams/social-share.png"
      imageFm="png8"
    />

    <Main>
      <Hero />

      <Companies />

      <Highlights />

      <TheSuperHiWay />

      <CommunityContent title="What people say" borders />

      <Plans />

      {faqs && <FAQs title="Questions?" {...faqs} />}
    </Main>
  </Page>
)

Teams.route = ROUTE

export { getStaticProps } from './data'
export default Teams
